export const ACTION_UPDATE_USERPROFILE = '/Account/UpdateUserProfile';